// Errors
export const REQUEST_FAILED_ERROR_MESSAGE =
    "Sorry, your request failed. Please retry, or call SiSU Support if the problem persists on 0402 675 769.";
export const NO_NETWORK_ERROR_MESSAGE =
    "It appears that you are not connected to Internet. Please retry or check your network connection.";
